<template>
  <div>
    <!-- <dropdown-boolean :v-model=task.repeat></dropdown-boolean> -->
    <b-row>
      <b-col md="4">
        <b-form-group label-for="repeat" :label="$t('scheduler.task.repeat')">
             
          <b-form-select
            id="repeat"
            :options="optionsBoolean"
            v-model="task.repeat"
            :disabled="readonly"
          ></b-form-select>
          <span class="text-danger" v-if="modelstate['Repeat']">
            {{ modelstate["Repeat"][0] }}
          </span>
        </b-form-group>
      </b-col>
    </b-row>

    <div v-if="isUniqueEvent">
      <b-row>
        <b-col>
          <b-form-group
            label-for="dateDayBegin"
            :label="$t('scheduler.task.dateDayEvent')"
          >
            <b-form-input
              id="dateDayEvent"
              type="date"
              :placeholder="$t('scheduler.task.dateDayEvent')"
              v-model="taskUnique.dateDayEvent"
              v-on:change="dayEventChanged($event)"
              :readonly="readonly"
            >
            </b-form-input>
            <span class="text-danger" v-if="modelstate['DateDayBegin']">
              {{ modelstate["DateDayBegin"][0] }}
            </span>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label-for="eventHourStart"
            :label="$t('scheduler.task.eventHourStart')"
          >
            <b-form-input
              id="eventHourStart"
              type="time"
              :placeholder="$t('scheduler.task.eventHourStart')"
              v-model="task.eventHourStart"
              :readonly="readonly"
            />
            <span class="text-danger" v-if="modelstate['EventHourStart']">
              {{ modelstate["EventHourStart"][0] }}
            </span>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label-for="eventHourEnd"
            :label="$t('scheduler.task.eventHourEnd')"
          >
            <b-form-input
              id="eventHourEnd"
              type="time"
              :placeholder="$t('scheduler.task.eventHourEnd')"
              v-model="task.eventHourEnd"
              :readonly="readonly"
            />
            <span class="text-danger" v-if="modelstate['EventHourEnd']">
              {{ modelstate["EventHourEnd"][0] }}
            </span>
          </b-form-group>
        </b-col>
      </b-row>
    </div>
    <div v-else>
      <b-row>
        <b-col md="4">
          <b-form-group
            label-for="intervalType"
            :label="$t('scheduler.task.intervalType')"
          >
            <b-form-select
              id="intervalType"
              :options="optionsIntervalType"
              v-model="task.intervalType"
              :disabled="readonly"
            >
            </b-form-select>
            <span class="text-danger" v-if="modelstate['IntervalType']">
              {{ modelstate["IntervalType"][0] }}
            </span>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="4">
          <b-form-group label-for="intervalRange" :label="intervalRangeLabel">
            <b-form-input
              id="intervalRange"
              type="text"
              :placeholder="intervalRangeLabel"
              v-model="task.intervalRange"
              :readonly="readonly"
            />
            <span class="text-danger" v-if="modelstate['IntervalRange']">
              {{ modelstate["IntervalRange"][0] }}
            </span>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="4">
          <b-form-group
            label-for="dateDayBegin"
            :label="$t('scheduler.task.dateDayBegin')"
          >
            <b-form-input
              id="dateDayBegin"
              type="date"
              :placeholder="$t('scheduler.task.dateDayBegin')"
              v-model="task.dateDayBegin"
              :readonly="readonly"
            />
            <span class="text-danger" v-if="modelstate['DateDayBegin']">
              {{ modelstate["DateDayBegin"][0] }}
            </span>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group
            label-for="dateDayEnd"
            :label="$t('scheduler.task.dateDayEnd')"
          >
            <b-form-input
              id="dateDayEnd"
              type="date"
              :placeholder="$t('scheduler.task.dateDayEnd')"
              v-model="task.dateDayEnd"
              :readonly="readonly"
            />
            <span class="text-danger" v-if="modelstate['DateDayEnd']">
              {{ modelstate["DateDayEnd"][0] }}
            </span>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="4">
          <b-form-group
            label-for="eventHourStart"
            :label="$t('scheduler.task.eventHourStart')"
          >
            <b-form-input
              id="eventHourStart"
              type="time"
              :placeholder="$t('scheduler.task.eventHourStart')"
              v-model="task.eventHourStart"
              :readonly="readonly"
            />
            <span class="text-danger" v-if="modelstate['EventHourStart']">
              {{ modelstate["EventHourStart"][0] }}
            </span>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group
            label-for="eventHourEnd"
            :label="$t('scheduler.task.eventHourEnd')"
          >
            <b-form-input
              id="eventHourEnd"
              type="time"
              :placeholder="$t('scheduler.task.eventHourEnd')"
              v-model="task.eventHourEnd"
              :readonly="readonly"
            />
            <span class="text-danger" v-if="modelstate['EventHourEnd']">
              {{ modelstate["EventHourEnd"][0] }}
            </span>
          </b-form-group>
        </b-col>
      </b-row>
    </div>

    <b-form-group
      label-for="description"
      :label="$t('scheduler.task.description')"
    >
      <b-form-input
        id="description"
        type="text"
        :placeholder="$t('scheduler.task.description')"
        v-model="task.description"
        :readonly="readonly"
      />
      <span class="text-danger" v-if="modelstate['Description']">
        {{ modelstate["Description"][0] }}
      </span>
    </b-form-group>

    <b-row>
      <b-col md="8">
        <b-form-group
          label="Perfil"
          label-for="input-form-profile-fill"
          class="mb-4"
        >
          <b-form-select
            id="input-form-profile-fill"
            v-model="task.profileId"
            required
            :options="optionsProfiles"
            :disabled="readonly"
          />
          <span class="text-danger" v-if="modelstate['ProfileId']">
            {{ modelstate["ProfileId"][0] }}
          </span>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="8">
        <b-form-group label="Usuário" label-for="UserId" class="mb-4">
          <b-form-select
            id="UserId"
            v-model="task.userId"
            required
            :options="optionsUsers"
            :disabled="readonly"
          />
          <span class="text-danger" v-if="modelstate['UserId']">
            {{ modelstate["UserId"][0] }}
          </span>
        </b-form-group>
      </b-col>
    </b-row>

    <!-- <div>{{ modelstate }}</div> -->
    <!-- <div> {{ task }} </div> -->
    <!-- <div> {{ taskUnique }} </div> -->
  </div>
</template>

<script>
export default {
  name: "Task",
  // components: {
  //     DropdownBoolean: () => import('@/components_rms/base/DropdownBoolean.vue'),
  // },
  props: {
    task: {
      type: Object,
      default: function () {
        return {
          repeat: false,
          intervalType: "",
          intervalRange: "",
          dateDayBegin: "",
          dateDayEnd: "",
          eventHourStart: "",
          eventHourEnd: "",
          description: "",
          profileId: null,
          userId: null,
        };
      },
      description: "Task",
    },
    modelstate: {
      type: Object,
      default: function () {
        return {};
      },
      description: "Modelstate",
    },
    readonly: {
      type: Boolean,
      default: false,
      description: "Readonly",
    },
  },
  data: function () {
    return {
      taskUnique: {
        dateDayEvent: "",
      },
      optionsBoolean: [
        { value: true, text: "Sim" },
        { value: false, text: "Não" },
      ],
      optionsIntervalType: [
        { value: "H", text: "Hora" },
        { value: "D", text: "Diário" },
        { value: "W", text: "Semanal" },
        { value: "M", text: "Mensal" },
        { value: "Y", text: "Anual" },
      ],
      optionsProfiles: [],
      optionsUsers: [],
    };
  },
  computed: {
    intervalRangeLabel() {
      if (this.task) {
        switch (this.task.intervalType) {
          case "H":
            return this.$t("scheduler.task.intervalRange") + " (Horário)";
          case "D":
            return this.$t("scheduler.task.intervalRange") + " (Diário)";
          case "W":
            return this.$t("scheduler.task.intervalRange") + " (Semanal)";
          case "M":
            return this.$t("scheduler.task.intervalRange") + " (Mensal)";
          default:
            return this.$t("scheduler.task.intervalRange") + " (Anual)";
        }
      }
      return this.$t("scheduler.task.intervalRange");
    },
    isUniqueEvent() {
      if (this.task) {
        return !this.task.repeat;
      }
      return false;
    },
  },
  created: function () {
    this.loadOptionsProfiles();
    this.loadOptionsUsers();
  },
  methods: {
    dayEventChanged(e) {
      if (this.task) {
        if (this.taskUnique) {
          this.task.dateDayBegin = this.taskUnique.dateDayEvent;
          this.task.dateDayEnd = this.taskUnique.dateDayEvent;
        }
      }
    },
    intervalTypeChanged(e) {
      if (this.task) {
        if (this.isUniqueEvent()) {
          this.task.dateDayBegin = null;
          this.task.dateDayEnd = null;
          this.task.intervalRange = null;
        } else {
          this.task.dateDayEvent = null;
          this.task.eventHourStart = null;
          this.task.eventHourEnd = null;
        }
      }
    },
    loadOptionsProfiles() {
      this.$apiScheduler
        .get("/profile/getCompanyProfiles/")
        .then((response) => {
          this.optionsProfiles = [{ value: null, text: "Todos os perfis" }];
          response.data.forEach((x) => {
            this.optionsProfiles.push({
              value: x.id,
              text: x.displayName,
            });
          });
        });
    },
    loadOptionsUsers() {
      this.$apiScheduler
        .get("/v1/user/company/dropdownOptions")
        .then((response) => {
          this.optionsUsers = [{ value: null, text: "Todos os usuários" }];
          response.data.forEach((x) => {
            this.optionsUsers.push({
              value: x.id,
              text: x.displayName,
            });
          });
        });
    },
  },
  watch: {
    task() {
      if (this.task) {
        this.taskUnique.dateDayEvent = this.task.dateDayBegin;
      }
    },
  },
};
</script>